import { Box, Chip } from "@mui/material";
import underscoreReplacer from "../utils/helpers/underscoreReplacer";

const ChipsRow = ({
    items,
    max = 6,
    size = "small",
    colorBg,
    outlined = false,
}: {
    items?: string[];
    max?: number;
    size?: "small" | "medium";
    colorBg?: string;
    outlined?: boolean;
}) => {
    if (!items?.length) return null;
    const visible = items.slice(0, max);
    const extra = items.length - visible.length;
    const colorBgSx = colorBg ? { backgroundColor: colorBg } : {};

    return (
        <Box sx={{ display: "flex", gap: 0.5, flexWrap: "wrap", mt: 0.75 }}>
            {visible.map((t) => (
                <Chip
                    key={t}
                    size={size}
                    label={underscoreReplacer(t)}
                    variant={outlined ? "outlined" : "filled"}
                    sx={{ ...colorBgSx, cursor: "default" }}
                    onClick={() => {}}
                />
            ))}
            {extra > 0 && <Chip onClick={() => {}} size={size} label={`+${extra} more`} sx={{ cursor: "default" }} variant="outlined" />}
        </Box>
    );
};

export default ChipsRow;
